import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import ReactGA from 'react-ga'
import { PAGES, getProfessionalCategory } from '../../utils/constants'

import logoPetanjo from '../../assets/logo-petanjo.svg'
import * as S from './styles'

const Footer = ({ privateRoute, isVet = false }) => {
  const history = useHistory()
  const location = useLocation()
  const isLogged = !!localStorage.getItem('userData')
  const { professional } = JSON.parse(localStorage.getItem('userData')) || {}
  const isNotLoginUrl = location.pathname !== '/login'
  const isNotPrivacyPolicyUrl = location.pathname !== '/vets/privacy-policy'
  const isNotUseTerm = location.pathname !== '/vets/termo-de-uso'
  const isNotForgotPasswordUrl = location.pathname !== `${PAGES.FORGOT_PASSWORD_URL}`
  const isNotCreatingPasswordUrl = location.pathname !== `${PAGES.CREATE_PASSWORD_URL}`
  const isFreelance = getProfessionalCategory() === 'FREELANCE'
  const isNotLeasing = getProfessionalCategory() !== 'LEASING'
  const isFranchising = getProfessionalCategory() === 'FRANCHISING'
  const hasMainProfessionalFranchising = professional?.mainProfessional?.category === 'FRANCHISING'
  const showPrivacyPolicy = isNotLoginUrl && isNotForgotPasswordUrl && isNotCreatingPasswordUrl && isNotPrivacyPolicyUrl && isLogged && isNotLeasing && isNotUseTerm && (isFranchising || (isFreelance && hasMainProfessionalFranchising))

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  return (
    <S.Container privateRoute={privateRoute}>
      <S.GroupLogo>
        <S.Logo src={logoPetanjo} alt="logo petanjo" />
      </S.GroupLogo>
      <S.Text>
      A Pet Anjo realiza, através de uma plataforma proprietária de agendamento online, o papel de intermediação na contratação de serviços prestados entre usuários e empresas especializadas em serviços para Pet, nas áreas de Banho & Tosa e Clínica Veterinária. Através desta plataforma, usuários podem contratar os serviços oferecidos por estas empresas parceiras que atuam com responsabilidade própria. Empresas parceiras e usuários reconhecem expressamente que a Pet Anjo não é parte de quaisquer acordos celebrados na relação de contratação dos serviços.</S.Text>
      {showPrivacyPolicy &&
        <>
          <S.Link onClick={() => goToPage(isVet ? 'vets/privacy-policy' : 'privacy-policy')}>Política de privacidade</S.Link>
          {isVet && (
            <S.Link onClick={() => goToPage('vets/termo-de-uso')}>Termos de uso</S.Link>
          )}
        </>
      }
    </S.Container>
  )
}

export default Footer
